import React, { useEffect, useState } from 'react'
import './SquareHighlight.css';
import selectEditIcon from '../../assets/icons/configurationIcons/selector-edit.svg'
import selectDeleteIcon from '../../assets/icons/configurationIcons/selector-delete.svg'
import { Button } from '@material-ui/core';
import * as helper from "../../helpers/helper";


function SquareHighlight({ x, y, width, height, colorCode, handleEditClickedArea, handleDeleteClickedArea, isResizable, resize, saveNewSize, handleChangeClickArea, handleChangeNeighborArea, isHover }) {
    const [isDragging, setIsDragging] = useState(false);
    const [isResize, setIsResize] = useState(false);
    const [isMoving, setIsMoving] = useState(false);
    const [isUpWorked, setIsUpWorked] = useState(false);
    // const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const labelStyle = {
        position: 'absolute',
        left: colorCode === "red" ? -70 : -90,
        top: -20,
        backgroundColor: '#000',
        color: 'white',
        padding: '0px 5px',
        fontSize: '11px',
        display: "none",
    }

    const configButtons = {
        position: 'absolute',
        left: -2,
        bottom: -2,
        backgroundColor: 'transparent',
        color: 'white',
        fontSize: '11px',
        display: "none",
        width: width + 22 + "px",
        height: height + 22 + "px",
        zIndex: 999
    }

    const squareStyle = {
        position: 'absolute',
        left: x,
        top: y,
        width: width,
        height: height,
        backgroundColor: colorCode === "red" ? 'rgba(255, 0, 0, 0.5)' : 'rgba(0, 255, 0, 0.5)',
        border: '2px solid ' + colorCode === "red" ? 'rgba(255, 0, 0, 0)' : 'rgba(0, 255, 0, 0)',
        boxSizing: 'border-box',
        zIndex: colorCode === "red" ? 101 : 100,
        cursor: isResizable ? "grabbing" : "grab",

    };


    const handleMouseDownForResize = (event) => {
        event.preventDefault(); // Fare tıklamasının varsayılan davranışını engeller
        setIsResize(true)
        const popImg = document.getElementById("popupImg")
        const { left, top } = popImg.getBoundingClientRect();
        const imageWidth = popImg.offsetWidth
        const imageHeight = popImg.offsetHeight
        const startX = event.clientX - left; // Fare tıklama noktasının X koordinatı
        const startY = event.clientY - top; // Fare tıklama noktasının Y koordinatı
        const startWidth = width; // Div öğesinin başlangıç genişliği
        const startHeight = height; // Div öğesinin başlangıç yüksekliği

        const handleMouseMove = (event) => {
            setIsMoving(true)
            const currentX = event.clientX - left
            const currentY = event.clientY - top
            const newWidth = startWidth + currentX - startX;
            const newHeight = startHeight + currentY - startY;

            resize([
                x,
                y,
                newWidth,
                newHeight
            ], {
                imageLeft: left,
                imageTop: top,
                imageWidth,
                imageHeight
            })
        };

        const handleMouseUpTrigger = () => {
            const highlightElement = document.querySelector(colorCode === "red" ? `.selected-area` : `.neighbor-area`)
            const elementWidth = highlightElement.offsetWidth
            const elementHeight = highlightElement.offsetHeight
            let x = parseFloat(highlightElement.style.left)
            let y = parseFloat(highlightElement.style.top)
            handleMouseUp(undefined, "resize", x, y, elementWidth, elementHeight)

            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUpTrigger);
        };

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUpTrigger);
    };

    const handleMouseDownForDrag = (event) => {
        setIsUpWorked(false)
        const popImg = document.getElementById("popupImg")
        const { left, top } = popImg.getBoundingClientRect();
        const imageWidth = popImg.offsetWidth
        const imageHeight = popImg.offsetHeight
        event.preventDefault();
        let clientX = event.clientX - left;
        let clientY = event.clientY - top;
        // setDragStart({ x: clientX, y: clientY });

        const handleMouseMove = (event) => {
            if (event.buttons === 2 || event.buttons === 4) return
            setIsDragging(true);
            // if (!isDragging) return;
            let currentX = event.clientX - left;
            let currentY = event.clientY - top;
            const deltaX = currentX - clientX;
            const deltaY = currentY - clientY;
            if (!isMoving) {
                setIsMoving(true)
            }
            resize([
                x + deltaX,
                y + deltaY,
                width,
                height,
            ], {
                imageLeft: left,
                imageTop: top,
                imageWidth,
                imageHeight
            })

            // setDragStart({ x: clientX, y: clientY });
        };

        const handleMouseUpTrigger = (event) => {
            const highlightElement = document.querySelector(colorCode === "red" ? `.selected-area` : `.neighbor-area`)
            let x = parseFloat(highlightElement.style.left)
            let y = parseFloat(highlightElement.style.top)
            x = Math.ceil(x)
            y = Math.ceil(y)
            // if (event.clientX - left < 0 || event.clientY - top < 0 || event.clientX + width >= imageWidth + left || (event.clientY - top) + height >= imageHeight + top) {
            //     let currentX = event.clientX - left < 0 ? 0 : (event.clientX - left) - (colorCode === "red" ? width / 2 : 0)
            //     let currentY = event.clientY - top < 0 ? 0 : (event.clientY - top) - (colorCode === "red" ? height / 2 : 0)
            //     if ((event.clientX - left) + width >= imageWidth || (event.clientY - top) + height >= imageHeight) {
            //         currentX = (event.clientX - left) + width >= imageWidth ? imageWidth - width : currentX
            //         currentY = (event.clientY - top) + height >= imageHeight ? imageHeight - height : currentY
            //     }
            //     handleMouseUp(undefined, true, currentX, currentY)
            // }
            if (x <= 0 || y <= 0 || x + width >= imageWidth || y + height >= imageHeight) {
                let currentX = x <= 0 ? 0 : x
                let currentY = y <= 0 ? 0 : y
                if (x + width >= imageWidth || y + height >= imageHeight) {
                    currentX = x + width >= imageWidth ? imageWidth - width : currentX
                    currentY = y + height >= imageHeight ? imageHeight - height : currentY
                }
                handleMouseUp(undefined, "drag", currentX, currentY)
            }
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUpTrigger);
        };

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUpTrigger);
    };

    // const handleMouseMove = (event) => {
    //     if (!isDragging) return;
    //     const popImg = document.getElementById("popupImg")
    //     const { left, top } = popImg.getBoundingClientRect();


    //     let clientX = event.clientX - left;
    //     let clientY = event.clientY - top;
    //     const deltaX = clientX - dragStart.x;
    //     const deltaY = clientY - dragStart.y;
    //     // const imageWidth = document.getElementById("scoped-image").offsetWidth;
    //     // const imageHeight = document.getElementById("scoped-image").offsetHeight;
    //     if (!isMoving) {
    //         setIsMoving(true)
    //     }
    //     if (y <= 0 || x <= 0) {
    //         resize([
    //             !(x <= 0) ? x + deltaX : 0.1,
    //             !(y <= 0) ? y + deltaY : 0.1,
    //             width,
    //             height
    //         ])
    //         return
    //     }
    //     // if (y <= 0 || x <= 0 || y + height >= imageHeight || x + width >= (imageWidth - 1)) {
    //     //     debugger;
    //     //     resize([
    //     //         !(x <= 0) ? x + deltaX : x + width >= imageWidth ? -(imageWidth + width + 0.1) : 0.1,
    //     //         !(y <= 0) ? y + deltaY : y + height >= imageHeight ? (height + 0.1) - imageHeight : 0.1,
    //     //         width,
    //     //         height
    //     //     ])
    //     //     return
    //     // }

    //     resize([
    //         x + deltaX,
    //         y + deltaY,
    //         width,
    //         height
    //     ])

    //     setDragStart({ x: clientX, y: clientY });
    // };

    const handleMouseUp = (e, access, currentX, currentY, newWidth, newHeight) => {
        if ((!isDragging && !isResize) && !access) return;
        setIsDragging(false);
        setIsResize(false);
        setIsMoving(false)
        if (!access) {
            setIsUpWorked(true)
        }
        saveNewSize(
            access === "drag" ? currentX : x <= 0 ? 0 : access === "resize" && currentX !== x ? currentX : x,
            access === "drag" ? currentY : y <= 0 ? 0 : access === "resize" && currentY !== y ? currentY : y,
            access === "resize" ? newWidth : width,
            access === "resize" ? newHeight : height
        )
    };

    return (
        <>
            {
                isResizable &&
                <div className={'transparent-resizable-parent'} style={{ width: `${width + 4}px`, height: `${height + 4}px`, left: `${x - 2}px`, top: `${y - 2}px` }}
                    onMouseDown={handleMouseDownForResize}
                    onMouseUp={isResizable && handleMouseUp}
                >
                </div >
            }
            <div
                id="highlightArea" className={colorCode === "red" ? "selected-area" : "neighbor-area"} style={squareStyle}
                onMouseDown={isResizable && handleMouseDownForDrag}
                // onMouseMove={isResizable && handleMouseMove}
                // onMouseLeave={isResizable && handleMouseUp}
                onClick={(e) => {
                    handleChangeClickArea && !isResize && !isDragging && !isUpWorked && handleChangeClickArea(e, x, y, width, height)
                }}
                onContextMenu={(e) => handleChangeNeighborArea && !isResize && !isDragging && !isUpWorked && handleChangeNeighborArea(e, x, y, width, height)}
                onMouseUp={isResizable && handleMouseUp}
            >
                {colorCode === "red" ? <span style={labelStyle}>ClickedArea</span> : <span style={labelStyle}>NeighbourArea</span>}
                {colorCode === "red" &&
                    <span className={!isMoving && 'config-selected-area'} style={configButtons}>
                        {!isHover &&
                            <Button onClick={handleEditClickedArea} className='selected-edit-container'>
                                <img src={selectEditIcon} className='selected-edit-button' />
                            </Button>
                        }
                        <Button onClick={handleDeleteClickedArea} className='selected-delete-container'>
                            <img src={selectDeleteIcon} className='selected-delete-button' />
                        </Button>
                    </span>}
            </div >
        </>
    );
}

export default SquareHighlight;